import React, { useCallback, useEffect, useState } from "react";
import { api } from "../api";
import PublicNavBar from "../components/PublicNavBar";
import PublicFooter from "../components/PublicFooter";
import HeroSection from "../components/landing/HeroSection";
import PromiseBar from "../components/landing/PromiseBar";
import StakeholdersSection from "../components/landing/StakeholdersSection";
import CapabilitiesAndImpact from "../components/landing/CapabilitiesAndImpact";
import HowItWorks from "../components/landing/HowItWorks";
import CoeLabsBand from "../components/landing/CoeLabsBand";
import FinalCTABand from "../components/landing/FinalCTABand";
import TrustedByStrip from "../components/landing/TrustedByStrip";
import GamificationStrip from "../components/landing/GamificationStrip";
import BuiltInIndiaBand from "../components/landing/BuiltInIndiaBand";

export default function Landing() {
  const [labs, setLabs] = useState([]);
  const [labsError, setLabsError] = useState(false);

  const loadLabs = useCallback(() => {
    setLabsError(false);
    api.get("/lms/labs")
      .then(r => setLabs(Array.isArray(r.data) ? r.data : []))
      .catch(() => setLabsError(true));
  }, []);

  useEffect(() => { loadLabs(); }, [loadLabs]);

  return (
    <div className="min-h-screen bg-white text-ink">
      <PublicNavBar />
      <HeroSection />
      <PromiseBar />
      <StakeholdersSection />
      <GamificationStrip />
      <CapabilitiesAndImpact />
      <HowItWorks />
      <CoeLabsBand labs={labs} labsError={labsError} onRetry={loadLabs} />
      <FinalCTABand />
      <BuiltInIndiaBand />
      <TrustedByStrip />
      <PublicFooter />
    </div>
  );
}
